import { createWebHashHistory, createRouter } from 'vue-router'

import HomeView from '../views/home/home_page.vue'
import article_page from  '../views/article/article_page.vue'
import article_detail_page from  '../views/article/article_detail_page.vue'


const routes = [
    { path: '/', component: HomeView },
    { path: "/article", component: article_page},
    { path: "/article_detail", component: article_detail_page},
]

const router = createRouter({
    //history: createMemoryHistory(),
    history: createWebHashHistory(),
    routes,
})

export default router;